import ViewQuestionnaireTopContainer from "./ViewQuestionnaireTopContainer";

export default ViewQuestionnaireTopContainer;
